export const products = [
  {
    id: 1,
    name: "Batik Tjap Parang Rusak",
    price: 350000,
    category: "Kain",
    image: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500",
    description: "Batik tjap dengan motif Parang Rusak klasik. Kain berkualitas premium dengan pewarnaan alami.",
    stock: 15,
    featured: true
  },
  {
    id: 2,
    name: "Batik Tjap Kawung",
    price: 320000,
    category: "Kain",
    image: "https://images.unsplash.com/photo-1622542796446-ferrxd1f3a8e?w=500",
    description: "Motif Kawung yang elegan, cocok untuk acara formal maupun casual.",
    stock: 20,
    featured: true
  },
  {
    id: 3,
    name: "Kemeja Batik Tjap Mega Mendung",
    price: 450000,
    category: "Kemeja",
    image: "https://images.unsplash.com/photo-1598554747436-c9293d6a588f?w=500",
    description: "Kemeja batik tjap motif Mega Mendung khas Cirebon dengan warna cerah.",
    stock: 12,
    featured: true
  },
  {
    id: 4,
    name: "Batik Tjap Truntum",
    price: 380000,
    category: "Kain",
    image: "https://images.unsplash.com/photo-1617127365659-c47fa864d8bc?w=500",
    description: "Batik Truntum dengan filosofi cinta yang tulus, cocok untuk pernikahan.",
    stock: 8
  },
  {
    id: 5,
    name: "Kemeja Batik Tjap Sido Mukti",
    price: 480000,
    category: "Kemeja",
    image: "https://images.unsplash.com/photo-1602810316498-ab67cf68c8e1?w=500",
    description: "Kemeja batik tjap motif Sido Mukti yang membawa keberuntungan.",
    stock: 10
  },
  {
    id: 6,
    name: "Batik Tjap Sekar Jagad",
    price: 400000,
    category: "Kain",
    image: "https://images.unsplash.com/photo-1618556420-0b1fa6606cd0?w=500",
    description: "Batik dengan motif beragam yang melambangkan keindahan dunia.",
    stock: 18
  },
  {
    id: 7,
    name: "Dress Batik Tjap Kombinasi",
    price: 550000,
    category: "Dress",
    image: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=500",
    description: "Dress batik modern dengan kombinasi motif tradisional.",
    stock: 7
  },
  {
    id: 8,
    name: "Batik Tjap Nitik Kombinasi",
    price: 420000,
    category: "Kain",
    image: "https://images.unsplash.com/photo-1610030469964-9e2e1d2f0b8d?w=500",
    description: "Batik tjap dengan motif Nitik yang halus dan detail.",
    stock: 14
  }
];

export const categories = ["Semua", "Kain", "Kemeja", "Dress"];